import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { Home, LucideIcon } from 'lucide-react';

interface NoBatchPlaceholderProps {
  icon: LucideIcon;
}

export const NoBatchPlaceholder: React.FC<NoBatchPlaceholderProps> = ({ icon: Icon }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center h-full gap-4 p-6">
      <Icon className="w-16 h-16 text-muted-foreground" />
      <p className="text-lg text-muted-foreground text-center">{t('cbs.batch.noBatch')}</p>
      <Button onClick={() => navigate('/')} className="gap-2">
        <Home className="w-4 h-4" />
        {t('common.goHome')}
      </Button>
    </div>
  );
};

export default NoBatchPlaceholder;
